import React, { useCallback, useState } from 'react'
import { DirectionsRenderer, DirectionsService } from "@react-google-maps/api";

function PlanDirect({origin,destination,transitPoints}:any) {
    const [currentDirection, setCurrentDirection] = useState<any>(null);
    const directionCallback = useCallback((googleRes:any)=>{
        if(googleRes){
            if(currentDirection){
                if(
                    googleRes.status === "OK" &&
                    googleRes.geocoded_waypoints.length !==
                    currentDirection.geocoded_waypoints.length
                ){
                    console.log("ルートが変更されたのでstateを更新する");
                    setCurrentDirection(googleRes);
                } else {
                    console.log("前回と同じルートのためstateを更新しない");
                  }
            } else{
                if (googleRes.status === "OK") {
                    console.log("初めてルートが設定されたため、stateを更新する");
                    setCurrentDirection(googleRes);
                  } else {
                    console.log("前回と同じルートのためstateを更新しない");
                  }
            }
        }
    },[currentDirection])
    console.log(origin)
    console.log(destination)
    console.log(transitPoints)
  return (
   <>
    <DirectionsService
     options={{
        origin,
        destination,
        travelMode:google.maps.TravelMode.DRIVING,
        optimizeWaypoints:true,
        waypoints: transitPoints
     }}
     callback={directionCallback}
    />
    {currentDirection !== null && (
        <DirectionsRenderer
         options={{directions:currentDirection}}
        />
    )}
   </>
  )
}

export default PlanDirect